module.exports = __webpack_public_path__ + "img/clothing76.90dce541.jpg";